var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSolidB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.10651 0.626245C0.287 0.243388 0.669857 0 1.09374 0H12.9076C13.3315 0 13.7144 0.243388 13.8948 0.626245C14.0753 1.0091 14.0206 1.46033 13.7526 1.78849L8.75088 7.90053V11.3763C8.75088 11.7072 8.56492 12.0108 8.26684 12.1585C7.96876 12.3061 7.61598 12.276 7.35072 12.0764L5.60051 10.7638C5.379 10.5997 5.25047 10.3399 5.25047 10.0637V7.90053L0.24598 1.78576C-0.0192858 1.46033 -0.0767144 1.00637 0.10651 0.626245Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSolidB);
export default __webpack_public_path__ + "static/media/filter-solid-b.65b4d3499e79054661c9dd1aae9780c1.svg";
export { ForwardRef as ReactComponent };